const QC_TYPE_LIST = [{
  label: '准确度',
  ctrlType: 3,
  defaultCtrlVal: 20,
  unit: '%',
  convert: val => parseFloat((val * 100).toFixed(2)),
  chartType: 'scatter',
  getFlag: (val, limit) => Math.abs(val) > limit
}, {
  label: '多点线性',
  ctrlType: 2,
  defaultCtrlVal: 0.995,
  unit: '',
  convert: val => val,
  chartType: 'bar',
  getFlag: (val, limit) => val < limit
}, {
  label: '检出限',
  ctrlType: 2,
  defaultCtrlVal: 0.15,
  unit: 'PPB',
  convert: val => val,
  chartType: 'bar',
  getFlag: (val, limit) => val > limit
}, {
  label: '精密度',
  ctrlType: 2,
  defaultCtrlVal: 10,
  unit: '%',
  convert: val => parseFloat((val * 100).toFixed(2)),
  chartType: 'scatter',
  getFlag: (val, limit) => val > limit
}, {
  label: '等浓度环比偏差',
  ctrlType: 3,
  defaultCtrlVal: 20,
  unit: '%',
  convert: val => parseFloat((val * 100).toFixed(2)),
  chartType: 'line',
  getFlag: (val, limit) => Math.abs(val) > limit
}, {
  label: '空白',
  ctrlType: 2,
  defaultCtrlVal: 0.15,
  unit: 'PPB',
  convert: val => val,
  chartType: 'bar',
  getFlag: (val, limit) => val > limit
}, {
  label: '保留时间漂移',
  ctrlType: 3,
  defaultCtrlVal: 20,
  unit: 's',
  convert: value => value,
  chartType: 'bar',
  getFlag: (val, limit) => Math.abs(val) > limit
}, {
  label: '流量',
  ctrlType: 3,
  defaultCtrlVal: 5,
  unit: '%',
  convert: val => parseFloat((val * 100).toFixed(2)),
  chartType: 'line',
  getFlag: (val, limit) => Math.abs(val) > limit
}, {
  label: 'F值变化趋势',
  ctrlType: 0,
  defaultCtrlVal: NaN,
  unit: '',
  convert: val => val,
  chartType: 'line',
  getFlag: (val, limit) => false
}, {
  label: '内标响应趋势',
  ctrlType: 0,
  defaultCtrlVal: NaN,
  unit: '',
  convert: val => val,
  chartType: 'line',
  getFlag: (val, limit) => false
}, {
  label: '超差率',
  ctrlType: 2,
  defaultCtrlVal: 20,
  unit: '%',
  convert: val => parseFloat((val * 100).toFixed(2)),
  chartType: 'line',
  getFlag: (val, limit) => Math.abs(val) > limit
}, {
  label: '内标响应趋势',
  ctrlType: 3,
  defaultCtrlVal: 50,
  unit: '%',
  convert: val => parseFloat((val * 100).toFixed(2)),
  chartType: 'scatter',
  // getFlag: (val, limit) => false
  getFlag: (val, limit) => Math.abs(val) > limit
}]

QC_TYPE_LIST.forEach((QC_TYPE, index) => {
  QC_TYPE.value = index + 1
})

export default {
  list: QC_TYPE_LIST,
  map: QC_TYPE_LIST.reduce((map, QC_TYPE) => {
    map[QC_TYPE.value] = QC_TYPE
    return map
  }, {})
}



// WEBPACK FOOTER //
// ./src/utils/qcTypeConfig.js